import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Cancelled = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM6.99731 15.7466L15.7467 6.99715C16.0906 6.65329 16.6533 6.65331 16.9972 6.99717C17.341 7.34104 16.9972 8.24759 16.9972 8.24759L8.24773 16.997C8.24773 16.997 7.34118 17.3409 6.99731 16.997C6.65345 16.6531 6.65345 16.0904 6.99731 15.7466Z"
        />
    </StarryUIIcon>
);
